import axios from 'axios';

export async function getPlans() {
  const response = await axios.get('/plans');
  return response.data;
}

export async function getPlans2026() {
  const response = await axios.get('/plans2026');
  return response.data;
}

export async function getPlan(planId, query) {
  const response = await axios.get(`/plans/${planId}`, {
    params: query
  });
  return response.data;
}

export async function getCheckoutPlan() {
  const response = await axios.get('/plans/checkout');
  return response.data;
}
